export function queueQuestionnairePageTextUpdate(pendingUpdates, metadataTag, value) {
    return {
        ...(pendingUpdates ?? {}),
        [metadataTag]: {metadataTag, value}
    };
}

export function discardQuestionnairePageTextUpdate(pendingUpdates, metadataTag) {
    if (!pendingUpdates) {
        return null;
    }

    const remainingUpdates = {...pendingUpdates};
    delete remainingUpdates[metadataTag];
    return Object.keys(remainingUpdates).length > 0 ? remainingUpdates : null;
}

export function applyQuestionnairePageTextUpdates(metadata, pendingUpdates) {
    if (!metadata || typeof metadata !== "object" || Array.isArray(metadata)) {
        throw new TypeError("Questionnaire metadata must be an object.");
    }

    const updatedMetadata = {...metadata};
    Object.values(pendingUpdates ?? {}).forEach(({metadataTag, value}) => {
        if (!Object.prototype.hasOwnProperty.call(updatedMetadata, metadataTag)) {
            return;
        }

        const metadataObject = JSON.parse(updatedMetadata[metadataTag]);
        if (!metadataObject || typeof metadataObject !== "object" || Array.isArray(metadataObject)) {
            throw new TypeError(`Questionnaire metadata "${metadataTag}" must contain an object.`);
        }
        metadataObject.defaultText = value;
        updatedMetadata[metadataTag] = JSON.stringify(metadataObject);
    });
    return updatedMetadata;
}
